import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Addproduct.css";

const AddProduct = () => {
    const [newProduct, setNewProduct] = useState({
        productName: "",
        productPrice: "",
        productWeight: "",
        productImage: null,
    });

    const [imagePreview, setImagePreview] = useState(null);
    const [imageName, setImageName] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!newProduct.productImage) {
            setImagePreview(null);
            return;
        }

        const objectUrl = URL.createObjectURL(newProduct.productImage);
        setImagePreview(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [newProduct.productImage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewProduct((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!file.type.startsWith("image/")) {
                setErrorMessage("❌ Please select a valid image file.");
                return;
            }
            setNewProduct((prev) => ({ ...prev, productImage: file }));
            setImageName(file.name);
            setErrorMessage("");
        }
    };

    const validateFields = () => {
        if (!newProduct.productName || !newProduct.productPrice || !newProduct.productWeight || !newProduct.productImage) {
            setErrorMessage("❌ All fields are required.");
            return false;
        }

        if (isNaN(newProduct.productPrice) || newProduct.productPrice <= 0) {
            setErrorMessage("❌ Price must be a valid positive number.");
            return false;
        }

        if (!Number.isInteger(Number(newProduct.productWeight)) || newProduct.productWeight <= 0) {
            setErrorMessage("❌ Weight must be a valid positive integer in grams.");
            return false;
        }

        setErrorMessage("");
        return true;
    };

    const handleSave = async () => {
        if (!validateFields()) return;

        try {
            setIsUploading(true);
            const formData = new FormData();

            const productData = JSON.stringify({
                productName: newProduct.productName,
                productPrice: newProduct.productPrice,
                productWeight: newProduct.productWeight,
            });

            formData.append("productData", productData);
            formData.append("image", newProduct.productImage);

            await axios.post("https://app.nkvairamaaligai.com/api/v1/admin/product", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
            });

            setSuccessMessage("✅ Product added successfully!");
            setErrorMessage("");
            setIsUploading(false);

            setNewProduct({ productName: "", productPrice: "", productWeight: "", productImage: null });
            setImageName("");
            setImagePreview(null);
            setUploadProgress(0);

            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            setErrorMessage("❌ Error saving product, please try again.");
            setSuccessMessage("");
            setIsUploading(false);
        }
    };

    return (
        <div className="add-product-section">
            <h3>Add Product</h3>
            <div className="form-container">
                <div className="form-inputs">
                    <input type="text" name="productName" placeholder="Name" value={newProduct.productName} onChange={handleInputChange} />
                    <input type="number" name="productPrice" placeholder="Price" value={newProduct.productPrice} onChange={handleInputChange} />
                    <input type="number" name="productWeight" placeholder="Weight (in grams)" value={newProduct.productWeight} onChange={handleInputChange} />

                    <input type="file" accept="image/*" onChange={handleImageChange} />
                    {imageName && <p className="image-name">📷 {imageName}</p>}

                    {uploadProgress > 0 && uploadProgress < 100 && (
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
                        </div>
                    )}

                    {successMessage && <p className="success-message">{successMessage}</p>}
                    {errorMessage && <p className="error-message">{errorMessage}</p>}

                    <button onClick={handleSave} disabled={isUploading}>
                        {isUploading ? "Uploading..." : "Save Product"}
                    </button>
                </div>

                {imagePreview && (
                    <div className={`image-preview-container ${imagePreview ? "show" : ""}`}>
                        <h4>Image Preview</h4>
                        <img src={imagePreview} alt="Product Preview" className="image-preview" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddProduct;
